import classNames from "classnames";
import React, { ReactNode } from "react";
import { KuikaSpinner as KuikaSpinnerSvg } from "../../design-tools/spinner/kuika-spinner";
import "./kuika-spinner-small.scss";

interface KuikaSpinnerSmallProps {
  size?: "small" | "default" | "large";
  spinning?: boolean;
  className?: string;
  children?: ReactNode;
  /**
   * Caption under the glyph, for work long enough that the reader wants to know what it is
   * waiting on ("Updating screens… 2/5"). The overlay spinner's `label`, in the inline one.
   */
  label?: string;
}

const KuikaSpinnerSmall: React.FC<KuikaSpinnerSmallProps> = ({
  size = "default",
  spinning = true,
  className = "",
  children,
  label
}) => {
  return (
    <div className={classNames("kuika-spinner-small-container", className)}>
      {spinning && (
        <div className={classNames("kuika-spinner-small-indicator", `kuika-spinner-small--${size}`)}>
          <KuikaSpinnerSvg className="kuika-spinner-small-indicator__spinner" />
          {label ? <div className="kuika-spinner-small-label">{label}</div> : null}
        </div>
      )}
      <div
        className={classNames("kuika-spinner-small-content", {
          "kuika-spinner-small-content--blur": spinning
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default KuikaSpinnerSmall;
